import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GuestPanelAuthService {

  constructor() { }

  public isAuthenticated(): boolean {
    if(localStorage.getItem('hotelGuestUserData')){
      return true
    }
    return false
  };

  public isGuestUserLogin(): boolean {
    if(localStorage.getItem('isSignIn') === 'true' && localStorage.getItem('hotelGuestUserData')){
      return true
    }
    return false
  };
}
